import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegionDashboardsExportButtons = _resolveComponent("RegionDashboardsExportButtons")!
  const _component_DashboardsCardFilterBlock = _resolveComponent("DashboardsCardFilterBlock")!

  return (_openBlock(), _createBlock(_component_DashboardsCardFilterBlock, {
    class: "region-dashboards-main-filter-block",
    filter: _ctx.filter,
    selectConfig: _ctx.getSelectConfig,
    isShowYearFilter: false,
    onChangeFilter: _ctx.changeFilter
  }, {
    controls: _withCtx(() => [
      _createVNode(_component_RegionDashboardsExportButtons, {
        class: "region-dashboards-main-filter-block__export",
        filter: _ctx.filter,
        plannedEventsRegionRfIds: _ctx.plannedEventsRegionRfIds,
        countryId: _ctx.countryId
      }, null, 8, ["filter", "plannedEventsRegionRfIds", "countryId"])
    ]),
    _: 1
  }, 8, ["filter", "selectConfig", "onChangeFilter"]))
}